<template>
  <v-content class="grey lighten-4">
    <AppBar title="Hållplats" :extension-height="110">
      <template v-slot:extension>
        <v-container class="py-0">
          <v-form>
            <v-row>
              <div class="d-flex flex-column align-center pt-3">
                <v-icon size="20" color="blue">mdi-radiobox-marked</v-icon>
                <div class="py-1">
                  <v-icon size="20" color="grey">mdi-dots-vertical</v-icon>
                </div>
                <v-icon size="20" color="red">mdi-map-marker</v-icon>
              </div>
              <v-col class="py-0">
                <v-autocomplete
                  v-model="location"
                  item-text="location"
                  item-value="location"
                  :items="locations"
                  :loading="$apollo.queries.locations.loading"
                  block
                  dense
                  outlined
                  clearable
                  hide-selected
                  hide-details
                  class="mb-3"
                  placeholder="Från hållplats"
                />
                <v-autocomplete
                  v-model="destination"
                  item-text="location"
                  item-value="location"
                  clearable
                  :items="locations"
                  :loading="$apollo.queries.locations.loading"
                  dense
                  block
                  outlined
                  hide-selected
                  hide-details
                  class="mb-3"
                  placeholder="Destination"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </template>
    </AppBar>
    <AppNavigationDrawer />

    <v-container class="px-0">
      <transition name="scroll-y-transition" mode="out-in">
        <v-row no-gutters v-if="filteredArrivals.length">
          <v-col>
            <OverviewListItem
              @click="openTrip(trip.trip_uuid)"
              :bus="trip"
              v-for="(trip, $i) in filteredArrivals"
              :key="$i"
            >
              <TripETA :trip="trip" />
              <v-btn icon><v-icon>mdi-map-search</v-icon></v-btn>
            </OverviewListItem>
          </v-col>
        </v-row>
        <v-row
          no-gutters
          v-else-if="arrivalsOnLocation && arrivalsOnLocation.length"
          class="d-flex flex-column align-center pt-12"
        >
          <v-icon size="50">mdi-information-outline</v-icon>
          <span class="grey--text text--darken-1 mt-4"
            >Inga ankomster till destination hittades</span
          >
        </v-row>
        <v-row no-gutters v-else class="d-flex flex-column align-center pt-12">
          <v-icon size="50">mdi-magnify</v-icon>
          <span class="grey--text text--darken-1 mt-4"
            >Sök på hållplats för att visa ankomster</span
          >
        </v-row>
      </transition>
    </v-container>
  </v-content>
</template>

<script>
import AppBar from '@/components/AppBar'
import AppNavigationDrawer from '@/components/AppNavigationDrawer'
import OverviewListItem from '@/components/OverviewListItem'
import TripETA from '@/components/TripETA'
import gql from 'graphql-tag'

export default {
  name: 'Stops',

  components: {
    AppBar,
    AppNavigationDrawer,
    OverviewListItem,
    TripETA
  },

  data: () => ({
    location: '',
    destination: null
  }),

  apollo: {
    locations: {
      query: gql`
        query {
          locations {
            location
          }
        }
      `
    },

    arrivalsOnLocation: {
      query: gql`
        query GetArrivalsOnLocation($location: String!) {
          arrivalsOnLocation(location: $location) {
            trip_uuid
            to
            via
            train
            type
            eta
          }
        }
      `,
      variables() {
        return {
          location: this.location || ''
        }
      }
    }
  },

  computed: {
    filteredArrivals() {
      return (this.arrivalsOnLocation || []).filter(
        x => !this.destination || x.via.includes(this.destination)
      )
    }
  },

  methods: {
    openTrip(trip_uuid) {
      this.$router.push(`/map-view/${trip_uuid}`)
    }
  }
}
</script>
